import React from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  ButtonGroup,
  DropdownButton,
} from 'react-bootstrap';
import Select from 'react-select';

import policyPlanStatuses from 'data/policy_plan_statuses';
import renewalMethodStatuses from 'data/renewal_method_statuses';
import renewalPeriodStatuses from 'data/renewal_period_statuses';

import BookOfBusinessReportButton from './BookOfBusinessReportButton';
import InvoiceForecastReportButton from './InvoiceForecastReportButton';
import AirtableSyncButton from './AirtableSyncButton';

export default function Filters({
  keyword,
  setKeyword,
  setPlanStatus,
  setRenewalMethod,
  setRenewalPeriod,
}) {
  return (
    <div className="invite_search">
      <Form className="" horizontal>
        <Row>
          <Col lg={9} style={{ width: '80%' }}>
            <Row>
              <Col md={6}>
                <FormGroup controlId="company_name">
                  <Col componentClass={ControlLabel} sm={4}>
                    Company Name
                  </Col>
                  <Col sm={8}>
                    <FormControl
                      type="text"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                  </Col>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup controlId="renewal_method">
                  <Col componentClass={ControlLabel} sm={4}>
                    Renewal Method
                  </Col>
                  <Col sm={8}>
                    <Select
                      isClearable
                      onChange={(option) => {
                        setRenewalMethod(option == null ? '' : option.value);
                      }}
                      options={renewalMethodStatuses}
                    />
                  </Col>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup controlId="status">
                  <Col componentClass={ControlLabel} sm={4}>
                    Status
                  </Col>
                  <Col sm={8}>
                    <Select
                      isClearable
                      onChange={(option) => {
                        setPlanStatus(option == null ? '' : option.value);
                      }}
                      options={policyPlanStatuses}
                    />
                  </Col>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup controlId="renewal_period">
                  <Col componentClass={ControlLabel} sm={4}>
                    Renewal Period
                  </Col>
                  <Col sm={8}>
                    <Select
                      isClearable
                      onChange={(option) => {
                        setRenewalPeriod(option == null ? '' : option.value);
                      }}
                      options={renewalPeriodStatuses}
                    />
                  </Col>
                </FormGroup>
              </Col>

            </Row>

          </Col>
          <Col lg={3} className="text-right" style={{ width: '20%' }}>
            <ButtonGroup vertical block>
              <DropdownButton title="Update Report" bsStyle="primary">
                <BookOfBusinessReportButton />
                <InvoiceForecastReportButton />
                <AirtableSyncButton />
              </DropdownButton>
            </ButtonGroup>
          </Col>
        </Row>

      </Form>
    </div>
  );
}
